import { useCallback, useEffect } from 'react';

import { Button, LinkButton, Modal } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { ResultModalContent } from 'shared/components/ResultModalContent';
import { LK_LINK } from 'shared/constants/links';
import { useAppDispatch, useLandingTracking } from 'shared/hooks';
import { selectModalStatus, selectModalVisible } from 'shared/selectors/modal';
import { setVisible } from 'shared/slices';
import { EBonusStatus } from 'shared/types/bonusStatus';

import { AuthenticationContainer } from '../AuthenticationContainer';
import { MODAL_CONTENT } from './constants';

export const ModalContainer: React.FC = () => {
  const status = useSelector(selectModalStatus);
  const visible = useSelector(selectModalVisible);
  const dispatch = useAppDispatch();
  const { trackBannerShow, trackBannerClose, trackBannerClick } = useLandingTracking();

  const isApplied = status === EBonusStatus.Applied;
  const isAwarded = status === EBonusStatus.Awarded;
  const isCanceled = status === EBonusStatus.Canceled;
  const isError = status === EBonusStatus.Error;

  useEffect(() => {
    if (!visible) {
      return;
    }

    trackBannerShow();
  }, [visible, trackBannerShow]);

  const handleModalVisible = useCallback(() => {
    trackBannerClose();
    dispatch(setVisible(false));
  }, [dispatch, trackBannerClose]);

  const handleBannerClick = useCallback(() => {
    trackBannerClick();
  }, [trackBannerClick]);

  const handleReloadPage = useCallback(() => {
    window.location.reload();
  }, []);

  const renderContent = () => {
    if (isApplied) {
      return (
        <ResultModalContent
          {...MODAL_CONTENT[0]}
          btn={
            <LinkButton href={LK_LINK} target="_blank" onClick={handleBannerClick}>
              {MODAL_CONTENT[0].btnText}
            </LinkButton>
          }
        />
      );
    }

    if (isAwarded) {
      return (
        <ResultModalContent
          {...MODAL_CONTENT[3]}
          btn={
            <LinkButton href={LK_LINK} target="_blank" onClick={handleBannerClick}>
              {MODAL_CONTENT[3].btnText}
            </LinkButton>
          }
        />
      );
    }

    if (isCanceled) {
      return (
        <ResultModalContent
          {...MODAL_CONTENT[1]}
          btn={
            <LinkButton href={LK_LINK} target="_blank" onClick={handleBannerClick}>
              {MODAL_CONTENT[1].btnText}
            </LinkButton>
          }
        />
      );
    }

    if (isError) {
      return (
        <ResultModalContent
          {...MODAL_CONTENT[2]}
          btn={<Button onClick={handleReloadPage}>{MODAL_CONTENT[2].btnText}</Button>}
        />
      );
    }

    return <AuthenticationContainer />;
  };

  return <Modal onOpenChange={handleModalVisible} open={visible} body={renderContent()} />;
};
